<template>
    <CRow>
        <CCol col>
            <div class="col-lg-12 control-section" style="padding:10px;position:relative;">
                <ejs-grid ref='grid' :dataSource="gridData" :allowFiltering='true' :commandClick='commandClick' :allowPaging="true" :allowTextWrap='true' :textWrapSettings='wrapSettings' :allowResizing='true' :query='gridQuery' :toolbarClick='toolbarClick' :allowExcelExport='true' :excelExportComplete='excelExportComplete' :allowReordering='true' :allowSorting='true' :editSettings='editSettings' :toolbar='toolbar' :pageSettings='pageSettings' :actionComplete='actionComplete' :actionBegin="actionBegin" :actionFailure="actionFailure" :filterSettings='filterOptions' :queryCellInfo='customiseCell'>
                    <e-columns>
                        <e-column field='triggerId' headerText='Id' width=120 :isPrimaryKey='true' :visible='false'></e-column>

                        <e-column field='utilityTypeId' headerText='Commodity' :validationRules="requiredRules" :visible='false' :index="1" width=90 :edit='utilitiesParams' foreignKeyField='utilityTypeId' foreignKeyValue='utilityTypeName' :dataSource='utilities' editType='dropdownedit'></e-column>
                        <e-column field='utilityTypeName' headerText='Commodity' :visible='false' width=90 type="string"></e-column>
                        <e-column field='productId' headerText='Product' :validationRules="requiredRules" width=70 :edit='productParams' foreignKeyField='id' foreignKeyValue='name' :dataSource='products' editType='dropdownedit'></e-column>
                        <e-column field='productName' headerText='Product' :visible='false' width=90 type="string"></e-column>
                        <e-column field='pricingAreaId' headerText='Price Area' :visible='false' width=120 foreignKeyField='id' :validationRules="priceAreaRequired" foreignKeyValue='name' :edit='priceAreaParams' :dataSource='priceArea' editType='dropdownedit'></e-column>
                        <e-column field='pricingAreaName' headerText='Price Area' textAlign='Left' width=120 type="string"></e-column>
                        <e-column field='tradeablePeriodId' headerText='Watched Period' textAlign='Right' :validationRules="requiredRules" editType='dropdownedit' :edit='tradebalePeriodParams' foreignKeyField="id" foreignKeyValue='name' :dataSource='tradebalePeriods' width=70></e-column>
                        <e-column field='tradeablePeriodName' headerText='Watched Period' :visible='false' width=120 type="string"></e-column>
                        <e-column field='triggerTypeId' headerText='Trigger Type' textAlign='Right' :validationRules="requiredRules" editType='dropdownedit' :edit='triggerTypeParams' foreignKeyField="id" foreignKeyValue='name' :dataSource='triggerTypes' width=70></e-column>
                        <e-column field='triggerTypeName' headerText='Trigger Type' :visible='false' width=120 type="string"></e-column>
                        <e-column field='tolerance' headerText='Tolerance' textAlign='Right' :validationRules="percentageRules" type="number" format="n1" editType='numericedit' :edit='percentageParams' width=70></e-column>
                        <e-column field='triggerPrice' headerText='Price' textAlign='Right' :validationRules="percentageRules" type="number" format="n3" editType='numericedit' :edit='numericParams' width=80></e-column>
                        <e-column field='referenceTypeId' headerText='Reference Type' textAlign='Right' :visible='false' :validationRules="requiredRules" editType='dropdownedit' :edit='referenceTypeParams' foreignKeyField="id" foreignKeyValue='name' :dataSource='referenceTypes' width=110></e-column>
                        <e-column field='referenceTypeName' headerText='Reference Type' :visible='false' width=120 type="string"></e-column>
                        <e-column headerText='Watched Window' :columns='dateColumns' textAlign="Center"></e-column>
                        <!--<e-column field='triggerStartDate' headerText='Start Date' textAlign='Right' :format='dateFormatOptions' type='date' :edit="startDateParams" width=90></e-column>
                        <e-column field='triggerEndDate' headerText='End Date' textAlign='Right' :format='dateFormatOptions' type='date' :edit="dpParams" width=90></e-column>-->
                        <e-column field='triggerStatus' headerText='Status' width=65 type="string"></e-column>
                        <e-column field='triggerActions' headerText='Trigger Actions' width=70 type="string"></e-column>
                        <e-column field='applyUntilEnd' headerText='Apply until Default Deadline' displayAsCheckBox='true' :visible='false' :edit='checkboxParams' editType='booleanedit' type='boolean' width=120></e-column>
                        <e-column field='notifyOnSystem' headerText='Notify On System' defaultValue='true' displayAsCheckBox='true' :visible='false' :allowEditing="false" editType='booleanedit' type='boolean' width=120></e-column>
                        <e-column field='notifyEmailAddresses' headerText='Notify Email Addresses' multiline="true" :edit="multilineParams" :visible='false' width=120></e-column>
                        <e-column field='contractId' headerText='contract ' :visible='false' width=120></e-column>
                        <e-column field='contractName' headerText='contract' :visible='false' width=120></e-column>
                        <e-column headerText='Actions' width=50 textAlign='left' :commands='commands'></e-column>

                    </e-columns>
                </ejs-grid>
                <ejs-dialog :allowDragging="draggable" :header="header" :position='position'  :buttons='alertDlgButtons' ref="alertDialog" v-bind:visible="false" :animationSettings='animationSettings' :showCloseIcon='showCloseIcon' :open="dialogOpen" :close="dialogClose" :target='target' :width='alertWidth'>
                    <ejs-chart id="contractTriggerContainer" :title='title' :zoomSettings='zoom' :primaryXAxis='primaryXAxis' :primaryYAxis='primaryYAxis' :tooltip='tooltip' :textRender='textRender' :titleStyle="titleStyle" width="700px" height="350px">
                        <e-series-collection>
                            <e-series xName='x' yName='y' name='Market Price' type='MultiColoredLine' pointColorMapping='color' :marker='marker'> </e-series>
                        </e-series-collection>
                    </ejs-chart>
                </ejs-dialog>
            </div>
        </CCol>
    </CRow>
</template>

<script>
    import Vue from "vue";
    import { GridPlugin, Edit, Page, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey, CommandColumn } from "@syncfusion/ej2-vue-grids";
    import { DropDownList } from "@syncfusion/ej2-dropdowns";
    import { UploaderPlugin } from '@syncfusion/ej2-vue-inputs';
    import { DialogUtility } from '@syncfusion/ej2-popups';
    import SyncHelper from '../../common/syncfusion';
    import { Query } from '@syncfusion/ej2-data';
    import gridOptions from '../../common/gridOptions'
    import dates from '../../common/dates'
    import urls from '../../common/urls';
    import apis from '../../common/network'
    import { DatePickerPlugin, DatePicker } from '@syncfusion/ej2-vue-calendars';
    import { CheckBoxPlugin, CheckBox } from "@syncfusion/ej2-vue-buttons";
    import { ChartPlugin, ColumnSeries, StripLine, LineSeries, DataLabel, Category, DateTime, Tooltip, ChartAnnotation, Zoom, MultiColoredLineSeries } from "@syncfusion/ej2-vue-charts";
    import { createSpinner, showSpinner, hideSpinner } from '@syncfusion/ej2-popups';
    import { DialogPlugin } from '@syncfusion/ej2-vue-popups';
    import { ButtonPlugin } from '@syncfusion/ej2-vue-buttons';
    import { enableRipple } from '@syncfusion/ej2-base';
    import { TextBox } from "@syncfusion/ej2-inputs";
    import store from '../../store';

    Vue.use(ChartPlugin);
    Vue.use(UploaderPlugin);
    Vue.use(DialogUtility);
    Vue.use(GridPlugin);

    Vue.use(ButtonPlugin);
    Vue.use(DialogPlugin);
    enableRipple(true);
    let referenceTypes = SyncHelper.getDataManager('Utils/referenceTypes');
    let triggerTypes = SyncHelper.getDataManager('Utils/triggerTypes');

    let tradebalePeriodObj, tradebalePeriodElem, triggerTypeObj, triggerTypeElem, referenceTypeObj, referenceTypeElem, datePickerObj, elem, startDatePickerObj, startDateElem, checkboxElem, checkBoxObj;
    let dpUtilities, elUtilities, dpProducts, elProducts, multilineElem, multilineObj, dpPriceArea, elPriceArea;
    export default {
        //props: ['parentContractId'],
        components: {
        },
        data() {
            return {
                // needed because of form being loaded from tab,in such cases this isnt available and store is loaded from import
                store: store,
                // needed for vieweing dialog,initally not there then appears
                showCloseIcon: false,
                target: '.control-section',
                alertWidth: '750px',
                alertHeight: '600px',
                animationSettings: { effect: 'Zoom' },
                alertDlgButtons: [{ click: this.alertDlgBtnClick, buttonModel: { content: 'Dismiss', isPrimary: true } }],
                ShowBtn: true,
                draggable: true,
                header: " ",
                priceAreaEnabled: store.state.hasPriceAreas,
                position: { X: 'center', Y: 'center' },
                zoom:
                {
                    enableMouseWheelZooming: true,
                    enablePinchZooming: true,
                    enableSelectionZooming: true
                },
                contractId: parseInt(store.state.selectedContractId),
                gridQuery: new Query().addParams("contractId", store.state.selectedContractId),
                // this is done due to header column
                dateColumns: [
                    {
                        field: 'triggerStartDate',
                        headerText: 'Start Date',
                        width: 75,
                        textAlign: 'Right',
                        minWidth: 10,
                        format: { type: 'date', format: 'dd/MM/yyyy' },
                        type: 'date',
                        validationRules: { required: true },
                        edit: {
                            create: function () {
                                startDateElem = document.createElement('input');
                                return startDateElem;
                            },
                            read: () => {
                                return startDatePickerObj.value;
                            },
                            destroy: () => {
                                startDatePickerObj.destroy();
                            },
                            // start date cant be before today,as trigger can start at least from today,cant set it up to start from yesterday as the job wont do data retroactivly
                            // max will be later set in the code to the last day of the period prior to the one chosen,as trading can be done until a period starts,and having trigger when you cant trade doesnt make sense
                            write: (args) => {
                                startDatePickerObj = new DatePicker({
                                    value: new Date(args.rowData[args.column.field]),
                                    floatLabelType: 'Always',
                                    format: 'dd/MM/yyyy',
                                    //sets the min.
                                    min: dates.addDays(new Date(), 1),
                                    placeholder: 'Start Date',
                                    firstDayOfWeek: 1,
                                });
                                startDatePickerObj.appendTo(startDateElem);
                            }
                        }
                    },
                    {
                        field: 'triggerEndDate',
                        headerText: 'End Date',
                        width: 75,
                        textAlign: 'Right',
                        minWidth: 10,
                        format: { type: 'date', format: 'dd/MM/yyyy' },
                        type: 'date',
                        validationRules: { required: true, minlength: [(args) => { return this.dateValidation(args) }, 'Start date can not be higher then end date'] },
                        edit: {
                            create: function () {
                                elem = document.createElement('input');
                                return elem;
                            },
                            read: () => {
                                return datePickerObj.value;
                            },
                            destroy: () => {
                                datePickerObj.destroy();
                            },
                            // end date cant be before tomorow,as trigger can start at least from today,cant set it up to start from yesterday as the job wont do data retroactivly,and it must last for at least a day
                            // max will be later set in the code to the last day of the period prior to the one chosen,as trading can be done until a period starts,and having trigger when you cant trade doesnt make sense
                            write: (args) => {
                                datePickerObj = new DatePicker({
                                    value: args.rowData[args.column.field] != undefined ? new Date(args.rowData[args.column.field]) : null,
                                    floatLabelType: 'Always',
                                    format: 'dd/MM/yyyy',
                                    //sets the min after the startdate.
                                    min: dates.addDays(new Date(), 1),
                                    placeholder: 'End Date',
                                    firstDayOfWeek: 1,
                                    cssClass: 'required-input',
                                });
                                datePickerObj.appendTo(elem);
                            }
                        }
                    }
                ],
                utilities: SyncHelper.getDataManager("utils/utilities/"),
                products: SyncHelper.getDataManager("utils/products/"),
                priceArea: SyncHelper.getDataManager("utils/pricingContractAreas"),
                referenceTypes: referenceTypes,
                triggerTypes: triggerTypes,
                contractUnits: "",
                riskManager: "",
                marketPricesPerDay: [],
                higherPrice: 0,
                lowerPrice: 0,
                title: "",
                type: "",
                max: 0,
                min: 0,
                wrapSettings: { wrapMode: 'Header' },
                commands: [{ buttonOption: { cssClass: 'e-primary', content: 'View' } }],
                tradebalePeriods: SyncHelper.getDataManager('Utils/tradeablePeriodsFiltered'),
                tradebalePeriodsDropwdown: SyncHelper.getDataManager('Utils/tradeablePeriodsFilteredDropdown'),
                dateFormatOptions: { type: 'date', format: 'dd/MM/yyyy' },
                gridData: SyncHelper.getDataManager("ContractTrigger"),
                utilitiesParams: {
                    create: () => {
                        elUtilities = document.createElement('input');
                        return elUtilities;
                    },
                    read: () => {
                        return dpUtilities.value;
                    },
                    destroy: () => {
                        dpUtilities.destroy();
                    },
                    write: (args) => {
                        dpUtilities = new DropDownList({
                            query: new Query().addParams("contractId", store.state.selectedContractId),
                            dataSource: this.utilities,
                            fields: {
                                text: args.column.foreignKeyValue,
                                value: args.column.foreignKeyField
                            },
                            //value: ((args.foreignKeyData && args.foreignKeyData[0]) ? args.foreignKeyData[0][args.column.foreignKeyField] : null),
                            index: 0,
                            placeholder: 'Commodity',
                            floatLabelType: 'Always',
                            cssClass: 'required-input',
                            change: () => {
                                //when choosing utility enable and setup products
                                dpProducts.enabled = true;
                                let tempQuery = new Query().where('utilityTypeId', 'equal', dpUtilities.value);
                                dpProducts.query = tempQuery;
                                dpProducts.text = null;
                                dpProducts.dataBind();
                            },
                        });
                        dpUtilities.appendTo(elUtilities);
                    }
                },
                productParams: {
                    create: () => {
                        elProducts = document.createElement('input');
                        return elProducts;
                    },
                    read: () => {
                        return dpProducts.value;
                    },
                    destroy: () => {
                        dpProducts.destroy();
                    },
                    write: (args) => {
                        dpProducts = new DropDownList({
                            query: new Query().addParams("contractId", store.state.selectedContractId),
                            dataSource: this.products,
                            fields: {
                                text: args.column.foreignKeyValue,
                                value: args.column.foreignKeyField
                            },
                            value: ((args.foreignKeyData && args.foreignKeyData[0]) ? args.foreignKeyData[0][args.column.foreignKeyField] : null),
                            placeholder: 'Product',
                            floatLabelType: 'Always',
                            cssClass: 'required-input',
                            enabled: true
                        });
                        dpProducts.appendTo(elProducts);
                    }
                },
                priceAreaParams: {
                    create: () => {
                        elPriceArea = document.createElement('input');
                        return elPriceArea;
                        console.log(elPriceArea)
                    },
                    read: () => {
                        return dpPriceArea.value;
                        console.log(dpPriceArea.value)
                    },
                    destroy: () => {
                        dpPriceArea.destroy();
                    },
                    write: (args) => {
                        dpPriceArea = new DropDownList({
                            dataSource: this.priceArea,
                            query: new Query().addParams("contractId", store.state.selectedContractId),
                            enabled: this.priceAreaEnabled,
                            fields: { text: args.column.foreignKeyValue, value: args.column.foreignKeyField },
                            value: ((args.foreignKeyData && args.foreignKeyData[0]) ? args.foreignKeyData[0][args.column.foreignKeyField] : null),
                            placeholder: 'Price Area',
                            floatLabelType: 'Always',
                            cssClass: this.priceAreaEnabled ? 'required-input' : '',
                            allowFiltering: true,
                            showClearButton: true,
                            change: (args) => {
                                console.log(args);
                            }
                        });

                        dpPriceArea.appendTo(elPriceArea);
                    }
                },
                tradebalePeriodParams:
                {
                    create: () => {
                        tradebalePeriodElem = document.createElement('input');
                        return tradebalePeriodElem;
                    },
                    read: () => {
                        return tradebalePeriodObj.value;
                    },
                    destroy: () => {
                        tradebalePeriodObj.destroy();
                    },
                    write: (args) => {
                        tradebalePeriodObj = new DropDownList({
                            query: args.requestType == "beginEdit" ? new Query().addParams("contractId", store.state.selectedContractId).addParams("triggerStatus", args.rowData.triggerStatus) : new Query().addParams("contractId", store.state.selectedContractId),
                            dataSource: this.tradebalePeriodsDropwdown,
                            fields: { text: args.column.foreignKeyValue, value: args.column.foreignKeyField },
                            value: ((args.foreignKeyData && args.foreignKeyData[0]) ? args.foreignKeyData[0][args.column.foreignKeyField] : null),
                            placeholder: 'Tradeable Period',
                            floatLabelType: 'Always',
                            cssClass: 'required-input',
                            change: (args) => {
                                //when period setup max dates to the last day of the period before
                                apis.protectedApi(`${urls.apiBaseUrl}ContractTrigger/PeriodDeadline/${args.value}`).then(it => {

                                    if (checkBoxObj.checked) {
                                        this.setEndDateValue(it);
                                        datePickerObj.enabled = false;
                                    }
                                    else {
                                        const dateString = it.data.lastDay;
                                        const parts = dateString.split("/");
                                        const formattedDate = new Date(parts[2], parts[1] - 1, parts[0]);
                                        datePickerObj.value = null;
                                        datePickerObj.max = new Date(formattedDate);
                                    }
  
                                    
                                }).catch(
                                    response => {
                                        var message = response.response.data.message != undefined ? response.response.data.message : "Error invoking service,please contact support";
                                        gridOptions.errorAlert("Error: " + message);
                                    }
                                );

                            }
                        });
                        tradebalePeriodObj.appendTo(tradebalePeriodElem);
                    }
                },
                referenceTypeParams: {
                    create: () => {
                        referenceTypeElem = document.createElement('input');
                        return referenceTypeElem;
                    },
                    read: () => {
                        return referenceTypeObj.value;
                    },
                    destroy: () => {
                        referenceTypeObj.destroy();
                    },
                    write: (args) => {
                        referenceTypeObj = new DropDownList({
                            dataSource: referenceTypes,
                            fields: { text: args.column.foreignKeyValue, value: args.column.foreignKeyField },
                            value: ((args.foreignKeyData && args.foreignKeyData[0]) ? args.foreignKeyData[0][args.column.foreignKeyField] : null),
                            placeholder: 'Reference Type',
                            cssClass: 'required-input',
                            floatLabelType: 'Always'
                        });
                        referenceTypeObj.appendTo(referenceTypeElem);
                    }
                },
                triggerTypeParams: {
                    create: () => {
                        triggerTypeElem = document.createElement('input');
                        return triggerTypeElem;
                    },
                    read: () => {
                        return triggerTypeObj.value;
                    },
                    destroy: () => {
                        triggerTypeObj.destroy();
                    },
                    write: (args) => {
                        triggerTypeObj = new DropDownList({
                            cssClass: ((args.foreignKeyData && args.foreignKeyData[0]) ? args.foreignKeyData[0][args.column.foreignKeyValue] == 'Lower' ? 'greenBox' : 'redBox' : null),
                            dataSource: triggerTypes,
                            fields: { text: args.column.foreignKeyValue, value: args.column.foreignKeyField },
                            value: ((args.foreignKeyData && args.foreignKeyData[0]) ? args.foreignKeyData[0][args.column.foreignKeyField] : null),
                            placeholder: 'Trigger Type',
                            cssClass: 'required-input',
                            floatLabelType: 'Always',
                            change: (args) => {
                                if (args.itemData.name == 'Lower') {
                                    args.element.parentElement.classList.remove('redBox');
                                    args.element.parentElement.classList.add('greenBox');
                                } else {
                                    args.element.parentElement.classList.remove('greenBox');
                                    args.element.parentElement.classList.add('redBox');
                                }
                            }
                        });
                        triggerTypeObj.appendTo(triggerTypeElem);

                    }
                },
                checkboxParams: {
                    create: function () {
                        checkboxElem = document.createElement('input');
                        return checkboxElem;
                    },
                    read: () => {
                        return checkBoxObj.checked;
                    },
                    destroy: () => {
                        checkBoxObj.destroy();
                    },

                    write: (args) => {
                        checkBoxObj = new CheckBox({
                            cssClass: 'e-primary',
                            checked: args.rowData[args.column.field],
                            disabled: false,
                            //value: args.rowData[args.column.field],
                            label: "Apply until End Date",
                            change: (args) => {
                                if (tradebalePeriodObj.value != undefined) {
                                    datePickerObj.enabled = args.checked == true ? false : true;
                                }
                                
                                if (args.checked && tradebalePeriodObj.value != undefined) {
                                    apis.protectedApi(`${urls.apiBaseUrl}ContractTrigger/PeriodDeadline/${tradebalePeriodObj.value}`).then(it => {
                                        this.setEndDateValue(it);
                                        store.state.lastDay = it.data.lastDay;
                                    }
                                    ).catch(
                                        response => {
                                            var message = response.response.data.message != undefined ? response.response.data.message : "Error invoking service,please contact support";
                                            gridOptions.errorAlert("Error: " + message);
                                        }
                                    );
                                }
                                

                            }

                        });
                        checkBoxObj.appendTo(checkboxElem);
                    }
                },
                multilineParams: {
                    create: function () {
                        multilineElem = document.createElement("textarea");
                        return multilineElem;
                    },
                    read: () => {
                        return multilineObj.value;
                    },
                    destroy: () => {
                        multilineObj.destroy();
                    },
                    write: args => {
                        multilineObj = new TextBox({
                            value: args.rowData["notifyEmailAddresses"],
                            floatLabelType: "Always",
                            placeholder: 'Notify Email Addresses',
                            multiline: true,

                        });
                        multilineObj.appendTo(multilineElem);
                    }
                },
                pageSettings: gridOptions.pageSettings,
                editSettings: {
                    showConfirmDialog: true,
                    showDeleteConfirmDialog: true,
                    allowEditing: store.state.permissions["Permissions.Triggers.Update"],
                    allowAdding: store.state.permissions["Permissions.Triggers.Create"],
                    allowDeleting: store.state.permissions["Permissions.Triggers.Delete"],
                    mode: 'Dialog'
                },
                numericParams: {
                    params: {
                        validateDecimalOnType: true,
                        decimals: 4,
                        format: "n4",
                        showSpinButton: false
                    }
                },
                percentageParams: {
                    params: {
                        validateDecimalOnType: true,
                        decimals: 1,
                        format: "n1",
                        min: 0
                    }
                },
                toolbar: ['Add', 'Edit', 'Delete', 'ExcelExport'],
                requiredRules: { required: true },
                percentageRules: { required: true, number: true },
                nameRules: { required: true, maxLength: 50 },
                editparams: { params: { popupHeight: '300px' } },
                filterOptions: gridOptions.filterSettings,
                priceAreaRequired: { required: store.state.hasPriceAreas },
                seriesData: this.marketPricesPerDay,
                primaryXAxis: {
                    valueType: 'DateTime', intervalType: 'Days',
                    title: 'Date'
                },
                primaryYAxis:
                {
                    minimum: this.min,
                    maximum: this.max,
                    interval: 3,
                    title: 'Price'
                },
                tooltip: { enable: true },
                titleStyle: {
                    fontFamily: "Arial",
                    fontStyle: 'italic',
                    fontWeight: 'regular',
                    color: "#E27F2D",
                    size: '23px'
                },
                title: this.title,
                marker: { dataLabel: { visible: true } },

            };
        },
        mounted() {
            createSpinner({
                target: document.getElementById('mainSpinner'),
                width: '50',
                type: 'Material',
                label: 'Loading data...',
                cssClass: 'loadingPoup'
            });
        },
        methods: {
            alertDlgBtnClick: function () {
                this.$refs.alertDialog.hide();
            },
            dialogClose: function () {
                this.ShowBtn = true;
            },
            dialogOpen: function () {
                this.ShowBtn = false;
            },
            dateValidation: function (args) {
                return startDatePickerObj.value <= datePickerObj.value;
            },
            textRender: function (args) {
                //if (this.type != "Lower" && args.point.y >= this.lowerPrice) {
                //    args.text = args.text + ' Trigger Hit';
                //    args.color = 'yellow';
                //}
                //else if (this.type == "Lower" && args.point.y <= this.higherPrice) {
                //    args.text = args.text + ' Trigger Hit';
                //    args.color = 'yellow';
                //}
                //else { args.text = ""; }
                args.text = "";
            },
            commandClick: function (args) {
                var triggerId = args.rowData.triggerId;
                this.loadGraph(triggerId);
            },
            loadGraph: function (args) {
                apis.protectedApi(`${urls.apiBaseUrl}ContractTrigger/TriggerGraphData/${args}`).then(it => {
                    this.higherPrice = it.data.higherPrice;
                    this.lowerPrice = it.data.lowerPrice;
                    this.marketPricesPerDay = it.data.marketPricesPerDay;
                    this.title = it.data.title;
                    this.type = it.data.type;
                    var chart = document.getElementById('contractTriggerContainer').ej2_instances[0];
                    chart.primaryYAxis =
                    {
                        minimum: it.data.min,
                        maximum: it.data.max,
                        interval: 3,
                        title: 'Price'
                    };
                    chart.primaryYAxis.stripLines =
                        [//striplines are for the green/red part lines on the grid, we have one that is the span,and the upper and lower one that deffer depending on type
                            { start: this.lowerPrice, end: this.higherPrice, text: this.type, color: this.type == "Lower" ? "palegreen" : '#b83726', visible: true, zIndex: 'Behind', opacity: 0.5 },

                            { start: this.type == "Lower" ? this.higherPrice : this.lowerPrice, size: 1, text: this.type == "Lower" ? "" + this.higherPrice : "" + this.lowerPrice, textStyle: { size: 15, color: this.type == "Lower" ? 'green' : "red" }, verticalAlignment: this.type == "Lower" ? "End" : "Start", horizontalAlignment: "Start", sizeType: 'Pixel', dashArray: "10,5", color: this.type == "Lower" ? "green" : 'red' },
                            { start: this.type == "Lower" ? this.lowerPrice : this.higherPrice, size: 1, text: this.type == "Lower" ? "" + this.lowerPrice : "" + this.higherPrice, textStyle: { size: 15, color: this.type == "Lower" ? "green" : 'red' }, verticalAlignment: this.type == "Lower" ? "Start" : "End", horizontalAlignment: "Start", sizeType: 'Pixel', color: this.type == "Lower" ? "green" : 'red' },

                        ];
                    chart.series[0].dataSource = this.marketPricesPerDay;
                    chart.refresh();
                    this.$refs.alertDialog.show();
                }
                ).catch(
                    response => {
                        var message = response.response.data.message != undefined ? response.response.data.message : "Error invoking service,please contact support";
                        gridOptions.errorAlert("Error: " + message);
                    }
                );
            },
            toolbarClick(args) {
                if (args.item.id.includes('excelexport')) {
                    // hide and show dropdown columns and show text columns as they always have value but dropdowns if not on the page will not have values
                    this.$refs.grid.getColumns()[3].visible = false;
                    this.$refs.grid.getColumns()[5].visible = false;
                    this.$refs.grid.getColumns()[7].visible = false;
                    this.$refs.grid.getColumns()[11].visible = false;

                    this.$refs.grid.getColumns()[4].visible = true;
                    this.$refs.grid.getColumns()[6].visible = true;
                    this.$refs.grid.getColumns()[8].visible = true;
                    this.$refs.grid.getColumns()[12].visible = true;
                }
                gridOptions.excelExport(args, "Contract Triggers.xlsx", this.$refs);
            },
            excelExportComplete(args) {
                this.$refs.grid.hideSpinner();
                // hide and show dropdown columns and show text columns as they always have value but dropdowns if not on the page will not have values,and return to the state before export
                this.$refs.grid.getColumns()[3].visible = true;
                this.$refs.grid.getColumns()[5].visible = true;
                this.$refs.grid.getColumns()[7].visible = true;
                this.$refs.grid.getColumns()[11].visible = false;

                this.$refs.grid.getColumns()[4].visible = false;
                this.$refs.grid.getColumns()[6].visible = false;
                this.$refs.grid.getColumns()[8].visible = false;
                this.$refs.grid.getColumns()[12].visible = false;
            },

            actionBegin(args) {
                gridOptions.actionBegin(args);
                if (args.requestType == 'beginEdit') {

                    if (args.rowData.triggerStatus == 'Expired') {
                        for (var i = 0; i < this.$refs.grid.getColumns().length; i++) {
                            this.$refs.grid.getColumns()[i].isPrimaryKey = true;

                        }
                    } else {
                        for (var i = 0; i < this.$refs.grid.getColumns().length; i++) {
                            this.$refs.grid.getColumns()[i].isPrimaryKey = false;

                        }
                    }
                }

                if (args.requestType === 'save') {
                    args.data['contractId'] = this.contractId;
                    showSpinner(document.getElementById('mainSpinner'));
                }
                if (args.requestType == 'refresh') {
                    hideSpinner(document.getElementById('mainSpinner'));


                }
                if (args.requestType === 'add') {
                    args.data['notifyEmailAddresses'] = "RM@trioadvisory.com;" + " " + this.riskManager;
                }
                // add columns needed for edit trigger,as all the data is trigger based,but on the table view it needs to be shown differently
                if ((args.requestType === 'beginEdit' || args.requestType === 'add')) {
                    for (var i = 0; i < this.$refs.grid.getColumns().length; i++) {
                        if (this.$refs.grid.getColumns()[i].headerText == "Apply until Default Deadline") {
                            this.$refs.grid.getColumns()[i].visible = true;
                        } else if (this.$refs.grid.getColumns()[i].field == "triggerActions") {
                            this.$refs.grid.getColumns()[i].visible = false;
                        } else if (this.$refs.grid.getColumns()[i].field == "triggerStatus") {
                            this.$refs.grid.getColumns()[i].visible = false;
                        } else if (this.$refs.grid.getColumns()[i].field == "applyUntilEnd") {
                            this.$refs.grid.getColumns()[i].visible = true;
                        } else if (this.$refs.grid.getColumns()[i].field == "notifyOnSystem") {
                            this.$refs.grid.getColumns()[i].visible = true;
                        } else if (this.$refs.grid.getColumns()[i].field == "notifyEmailAddresses") {
                            this.$refs.grid.getColumns()[i].visible = true;
                        } else if (this.$refs.grid.getColumns()[i].field == "utilityTypeId") {
                            this.$refs.grid.getColumns()[i].visible = true;
                        } else if (this.$refs.grid.getColumns()[i].field == "referenceTypeId") {
                            this.$refs.grid.getColumns()[i].visible = true;
                        } else if (this.$refs.grid.getColumns()[i].field == "pricingAreaId") {
                            this.$refs.grid.getColumns()[i].visible = true;
                        } else if (this.$refs.grid.getColumns()[i].field == "pricingAreaName") {
                            this.$refs.grid.getColumns()[i].visible = false;
                        }
                    }
                }
            },
            actionComplete(args) {
                gridOptions.actionComplete(args, this.$refs);
                if ((args.requestType === 'beginEdit' || args.requestType === 'add')) {
                    var applyEnd = args.rowData.applyUntilEnd;
                    if (applyEnd == true) {
                        datePickerObj.enabled = false;
                    }

                    const arrayFields = ["triggerStartDate", "triggerPrice","tolerance"]
                    arrayFields.forEach(function (item) {
                        let inputElement = args.form.elements.namedItem(item);
                        if (inputElement) {
                            let parentDiv = inputElement.closest('.e-input-group');
                            if (parentDiv) {
                                parentDiv.classList.add('required-input');
                            }
                        }
                    });
                }


                if (args.requestType == 'beginEdit') {

                    if (args.rowData.triggerStatus == 'Expired') {
                        for (var i = 0; i < this.$refs.grid.getColumns().length; i++) {
                            this.$refs.grid.getColumns()[i].isPrimaryKey = true;

                        }
                        dpUtilities.enabled = false;
                        tradebalePeriodObj.enabled = false;
                        dpProducts.enabled = false;
                        triggerTypeObj.enabled = false;
                        referenceTypeObj.enabled = false;
                        checkBoxObj.disabled = true;
                    } else {
                        for (var i = 0; i < this.$refs.grid.getColumns().length; i++) {
                            this.$refs.grid.getColumns()[i].isPrimaryKey = false;

                        }

                        dpUtilities.enabled = true;
                        tradebalePeriodObj.enabled = true;
                        dpProducts.enabled = true;
                        triggerTypeObj.enabled = true;
                        referenceTypeObj.enabled = true;
                        checkBoxObj.disabled = false;
                    }
                }


                if ((args.requestType === 'beginEdit' || args.requestType === 'add')) {
                    // set the open dialog int two columns
                    args.dialog.height = "65%";
                    args.dialog.width = "50%";
                    let rows = args.form.querySelectorAll("tr");
                    for (var i = 0; i < rows.length; i = i + 2) {
                        if (rows.length > i + 1) {
                            rows[i].appendChild(
                                args.form.querySelectorAll("tr")[i + 1].cells[0]
                            );
                        }
                    }


                    for (var i = 0; i < this.$refs.grid.getColumns().length; i++) {
                        if (this.$refs.grid.getColumns()[i].headerText == "Apply until Default Deadline") {
                            this.$refs.grid.getColumns()[i].visible = false;
                        } else if (this.$refs.grid.getColumns()[i].field == "triggerActions") {
                            this.$refs.grid.getColumns()[i].visible = true;
                        } else if (this.$refs.grid.getColumns()[i].field == "triggerStatus") {
                            this.$refs.grid.getColumns()[i].visible = true;
                        } else if (this.$refs.grid.getColumns()[i].field == "applyUntilEnd") {
                            this.$refs.grid.getColumns()[i].visible = false;
                        } else if (this.$refs.grid.getColumns()[i].field == "notifyOnSystem") {
                            this.$refs.grid.getColumns()[i].visible = false;
                        } else if (this.$refs.grid.getColumns()[i].field == "notifyEmailAddresses") {
                            this.$refs.grid.getColumns()[i].visible = false;
                        } else if (this.$refs.grid.getColumns()[i].field == "utilityTypeId") {
                            this.$refs.grid.getColumns()[i].visible = false;
                        } else if (this.$refs.grid.getColumns()[i].field == "referenceTypeId") {
                            this.$refs.grid.getColumns()[i].visible = false;
                        } else if (this.$refs.grid.getColumns()[i].field == "pricingAreaId") {
                            this.$refs.grid.getColumns()[i].visible = false;
                        } else if (this.$refs.grid.getColumns()[i].field == "pricingAreaName") {
                             this.$refs.grid.getColumns()[i].visible = true;
                        }
                    }

                    if (args.requestType != 'add') {
                        args.form[10].value = args.form[10].value + "%";  //add %sign here in the form
                        args.form[12].value = args.form[12].value + " [" + this.contractUnits + "]";  //add %sign here in the form
                    }
                    // on focus out return the % sign
                    args.form[10].addEventListener("focusout", e => {
                        if (e.target.classList.contains("e-numerictextbox")) {
                            e.target.value = e.target.value + "%";
                        }
                    });

                    args.form[12].addEventListener("focusout", e => {
                        if (e.target.classList.contains("e-numerictextbox")) {
                            e.target.value = e.target.value + " [" + this.contractUnits + "]";
                        }
                    });
                }
            },
            actionFailure(args) {
                gridOptions.actionFailure(args);
                hideSpinner(document.getElementById('mainSpinner'));
            },
            customiseCell: function (args) { // when setting up the grid this is rendering each column on its own
                if (args.column.field === 'triggerTypeId') {
                    if (args.data['triggerTypeName'] == 'Lower') {
                        args.cell.classList.add('greenBox');
                    } else {
                        args.cell.classList.add('redBox');
                    }
                } else if (args.column.field === 'triggerPrice') {
                    args.cell.textContent = args.cell.textContent + " [" + this.contractUnits + "]";//args.cell.headerText + " " + this.contractUnits;
                } else if (args.column.field === 'tolerance') {
                    args.cell.textContent = args.cell.textContent + "%";
                } else if (args.column.headerText === "Actions") {
                    if (args.data['triggerStatus'] != 'Live' && args.data['triggerStatus'] != 'Due Live') {
                        args.cell.querySelector("button[title='View']").ej2_instances[0].disabled = true;
                    }

                }

            },
            fetchData(id) {
                apis.protectedApi(`${urls.apiBaseUrl}Contract/AditionalTriggerData/${id}`).then(it => {
                    this.contractUnits = it.data.units;
                    this.riskManager = it.data.riskManager;
                    //set the default riskmanager email and units used on the contract to be loaded for edit dialog
                }
                ).catch(
                    response => {
                        var message = response.response.data.message != undefined ? response.response.data.message : "Error invoking service,please contact support";
                        gridOptions.errorAlert("Error: " + message);
                    }
                );

            },
            setEndDateValue(it) {
                const dateString = it.data.lastDay;
                const parts = dateString.split("/");
                const formattedDate = new Date(parts[2], parts[1] - 1, parts[0]);
                datePickerObj.setProperties({
                    value: formattedDate,
                });

                const datePickerInput = document.querySelector('[id$="triggerEndDate"]');

                if (datePickerInput) {
                    datePickerInput.removeAttribute('aria-invalid');
                    const parentDiv = datePickerInput.closest('.e-date-wrapper');
                    if (parentDiv) {
                        parentDiv.classList.remove('e-error');
                    }

                }

                const endDateErrorTooltip = document.getElementById("triggerEndDate_Error");

                if (endDateErrorTooltip && datePickerInput) {
                    endDateErrorTooltip.style.display = "none";
                }

            }

        },
        created: function () {
            this.fetchData(store.state.selectedContractId);
        },
        provide: {
            grid: [Page, Edit, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey, CommandColumn],
            chart: [ColumnSeries, StripLine, LineSeries, Category, DataLabel, DateTime, Tooltip, ChartAnnotation, Zoom, MultiColoredLineSeries]
        }
    };

</script>
<style>
/*    .e-dialog {
        max-height: 900px !important;
        top: 0px !important;
    }*/
    /*@import "../node_modules/@syncfusion/ej2-vue-grids/styles/material.css";*/
    .greenBox {
        background-color: #7FB7BE !important;
    }

    .redBox {
        background-color: #f78764 !important;
    }

    e-notFunctional {
        background-color: grey;
    }

    #contractTriggerContainer {
        height: 350px;
    }
    .required-input.e-float-input.e-control-wrapper .e-float-text::after {
        content: '*';
        color: red;
        margin-left: 4px;
    }

    .required-input .e-float-input.e-control-wrapper .e-float-text::after {
        content: '*';
        color: red;
        margin-left: 4px;
        font-weight: bold;
    }
</style>
